import React from 'react';
import SiteLayout from '../../layouts/SiteLayout';
import Header from '../../components/Header/Header';

const TenantRolesScreen: React.FC = () => {
    return (
        <SiteLayout>
            <Header icon='security' title='Gestion des Rôles Locaux' />
            <div style={{ padding: '20px', maxWidth: '1400px', margin: '0 auto' }}>
                <div className="admin-table-container">
                    <div style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>
                        <i className="material-icons" style={{ fontSize: '48px', marginBottom: '10px' }}>security</i>
                        <p>Gestion des rôles personnalisés pour votre organisation.</p>
                    </div>
                </div>
            </div>
        </SiteLayout>
    );
};

export default TenantRolesScreen;
